module.exports = __webpack_public_path__ + "img/BM.fc46aea1.svg";